export default __webpack_public_path__ + "083db6e3cb1cfc48e27bd2efa90b1ca7.png";